import React from "react";

/**
 * Standard page wrapper used across the authenticated app.
 * Keeps typography, spacing, and responsive layout consistent.
 */
export default function PageShell({
  title,
  subtitle,
  actions,
  children,
  breadcrumbs,
  className = "",
}) {
  return (
    <div className={`app-page ${className}`}>
      <div className="page-header">
        <div className="page-header__left">
          {breadcrumbs ? (
            <div className="page-breadcrumbs">{breadcrumbs}</div>
          ) : null}

          <h1 className="page-title">{title}</h1>

          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
        </div>

        {actions ? <div className="page-header__actions">{actions}</div> : null}
      </div>

      <div className="page-body">{children}</div>
    </div>
  );
}